import { render } from "./docs_tab.vue?vue&type=template&id=468dfacb"
import script from "./docs_tab.vue?vue&type=script&lang=js"
export * from "./docs_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__